module.exports = __webpack_public_path__ + "static/img/20230316_01.c16bbe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230316_01.png
// module id = FnrQ
// module chunks = 0